import React from 'react'
import Link from 'gatsby-link'

const LeftColumn = (props) => (

  <div className="column left">
    {props.content}
  </div>

)

export default LeftColumn



// WEBPACK FOOTER //
// ./src/components/LeftColumn.js